import React, { useState, useEffect } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { styled, keyframes } from '@mui/system';
import AILoadingAnimation from '../components/common/AILoadingAnimation';

const shimmerText = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const AILoadingContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  background: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  maxWidth: '100%',
  overflow: 'hidden',
  boxSizing: 'border-box',
}));

const AITypingEffect = ({ componentType, componentName, componentDescription, componentData }) => {
  const messages = ['Processing...', 'Analyzing...', 'Generating...', 'Finalizing...'];

  return (
    <AILoadingContainer>
      <AILoadingAnimation
        messages={messages}
        containerSx={{
          border: 'none',
          borderRadius: 0,
          background: 'transparent',
        }}
      />
    </AILoadingContainer>
  );
};

export const AIComponentLoadingSkeleton = () => {
  return (
    <Grid container paddingLeft={'16px'} paddingRight={'16px'} paddingTop={'24px'}>
      <Grid item xs={12}>
        <AIIndividualComponentLoader />
      </Grid>
    </Grid>
  );
};

export const AIIndividualComponentLoader = ({
  componentType,
  componentName,
  componentDescription,
  componentData,
  ...props
}) => {
  return (
    <AITypingEffect
      componentType={componentType}
      componentName={componentName}
      componentDescription={componentDescription}
      componentData={componentData}
      {...props}
    />
  );
};
